import React, { useState } from "react";
import {
    Paper,
    Stack,
    Button,
    TextField
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./ReportSetWiseTrip.css";
import ApiBaseURL from "../ApiBaseUrl/ApiBaseURL";

const ReportSetWiseTrip = () => {

    const [fromDate, setFromDate] = useState(dayjs());
    const [toDate, setToDate] = useState(dayjs());
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);

    const handleShowReport = async () => {
        try {
            setLoading(true);

            const userId = localStorage.getItem('userId');
            const token = localStorage.getItem('token');

            const response = await fetch(`${ApiBaseURL}/report/v1/get/trip-set-wise-report`,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                        userId: userId,
                    },
                    body: JSON.stringify({
                        startDateTime: fromDate.format("YYYY-MM-DD") + "T06:00:00",
                        endDateTime: toDate.format("YYYY-MM-DD") + "T06:00:00"
                    })
                }
            );

            const result = await response.json();

            if (result?.data) {
                setReportData(result.data);
            }

        } catch (err) {
            console.error("API Error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Paper className="p-3 mt-2">

            <h5 className="mb-3">Trip Set Wise Report</h5>

            {/* DATE FILTER */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
                    <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(v) => setFromDate(v)}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />

                    <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(v) => setToDate(v)}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />

                    <Button
                        variant="contained"
                        onClick={handleShowReport}
                    >
                        Show Report
                    </Button>
                </Stack>
            </LocalizationProvider>

            {/* TABLE */}
            {loading ? (
                <div className="text-center py-4">Loading...</div>
            ) : reportData ? (
                <table className="set-wise-table">
                    <thead>
                        <tr>
                            <th>SHIFT</th>
                            <th>Sr No</th>
                            <th>Set</th>
                            <th>Material Type</th>
                            <th>Vendor</th>
                            <th>TIPPER</th>
                            <th>TRIPS</th>
                            <th>Cubic Meter</th>
                        </tr>
                    </thead>

                    <tbody>
                        {reportData.shifts.map((shiftObj, sIndex) => (
                            <React.Fragment key={sIndex}>

                                {/* SHIFT ROWS */}
                                {shiftObj.rows.map((row, rIndex) => (
                                    <tr key={rIndex}>
                                        {rIndex === 0 && (
                                            <td
                                                rowSpan={shiftObj.rows.length + 1}
                                                className="fw-bold"
                                            >
                                                {shiftObj.shift}
                                            </td>
                                        )}

                                        <td>{rIndex + 1}</td>
                                        <td>{row.set}</td>
                                        <td>{row.materialType}</td>
                                        <td>{row.vendor}</td>
                                        <td>{row.tippers}</td>
                                        <td>{row.trips}</td>
                                        <td>{row.cubicMeter}</td>
                                    </tr>
                                ))}

                                {/* SHIFT TOTAL */}
                                <tr className="total-row">
                                    <td colSpan={4} className="text-end fw-bold">
                                        {shiftObj.shift} Total
                                    </td>
                                    <td className="fw-bold">{shiftObj.total.tippers}</td>
                                    <td className="fw-bold">{shiftObj.total.trips}</td>
                                    <td className="fw-bold">{shiftObj.total.cubicMeter}</td>
                                </tr>

                            </React.Fragment>
                        ))}

                        {/* GRAND TOTAL */}
                        <tr className="grand-total">
                            <td colSpan={5} className="fw-bold text-center">
                                Grand Total
                            </td>
                            <td>{reportData.grandTotal.tippers}</td>
                            <td>{reportData.grandTotal.trips}</td>
                            <td>{reportData.grandTotal.cubicMeter}</td>
                        </tr>

                    </tbody>
                </table>
            ) : (
                <div className="text-center py-4">No Data</div>
            )}

        </Paper>
    );
};

export default ReportSetWiseTrip;